import React from "react";
import styles from "./ResetFiltersLink.module.scss";
import {useTranslation} from "react-i18next";
import {useProductListContext} from "../../ProductListProvider/ProductListProvider";

const ResetFiltersLink: React.FC = () => {
  const {t} = useTranslation();
  const {dispatch} = useProductListContext();

  const resetAllFilter = () => {
    dispatch({type: "RESET"});
    dispatch({type: "TRIGGER"});
  };

  return (
    <span className={styles.wrapper} role="link" onClick={resetAllFilter}>
      {t("Alle Filter zurücksetzen")}
    </span>
  );
};

export default ResetFiltersLink;
